import { NavLink, useNavigate } from "react-router-dom";
import { unreadCount } from "./notificationsStore";
import { LogOut } from "lucide-react";
import { toast } from "react-toastify";

export default function AdminSidebar({ closeMenu = () => {} }) {
  const count = unreadCount();
  const navigate = useNavigate();

  function logout() {
    localStorage.removeItem("membreToken");
    localStorage.removeItem("membre");
    localStorage.removeItem("membreExpiresAt");

    toast.success("Déconnexion réussie !");

    navigate("/");

    if (typeof closeMenu === "function") {
      closeMenu();
    }
  }

  const link =
    "flex items-center justify-between px-4 py-3 rounded-lg text-sm font-medium hover:bg-gray-200 transition";

  const active = "bg-blue-600 text-white hover:bg-blue-700";

  return (
    <aside
      className="
        w-64 
        bg-white
        border-r
        shadow-sm 
        p-5 
        h-full
        flex flex-col
        fixed left-0 top-0 z-50
        md:static md:h-screen
      "
    >
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold">Admin Panel</h2>

        <button
          onClick={logout}
          className="p-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
          title="Déconnexion"
        >
          <LogOut size={18} />
        </button>
      </div>

      <nav className="space-y-3 flex-1 overflow-y-auto">
        <NavLink
          to="/admin"
          end
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          📊 Dashboard
        </NavLink>

        <NavLink
          to="/admin/inscriptions"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          📝 Inscriptions
        </NavLink>
        <NavLink
          to="/admin/members"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          👥 Gestion des Membres
        </NavLink>
        <NavLink
          to="/admin/activities"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          🎯 Gestion des Activités
        </NavLink>

        <NavLink
          to="/admin/subs"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          📧 Abonnés
        </NavLink>

        <NavLink
          to="/admin/newsletter"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          ✉️ Newsletter
        </NavLink>

        <NavLink
          to="/admin/notifications"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          🔔 Notifications
          {count > 0 && (
            <span className="bg-red-600 text-white text-xs px-2 py-1 rounded-full">
              {count}
            </span>
          )}
        </NavLink>

        <NavLink
          to="/admin/scan"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          📷 Scanner Présence
        </NavLink>

        <NavLink
          to="/admin/presences"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          📝 Présences du jour
        </NavLink>

        <NavLink
          to="/admin/presences-history"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? `${link} ${active}` : link)}
        >
          📅 Historique des Journées
        </NavLink>
      </nav>
    </aside>
  );
}
